module.exports = __webpack_public_path__ + "static/media/qempo-tiendas-logo.ef92178e.png";